import React, { useState } from 'react';
import { GetAllDriversMasterData_getAllDriversMasterData as Driver } from '../../types/schemaTypes';
import './DriverItem.scss';
import { formatDateUtcToLocal } from '../../utils/helpers/datetimeHelper';
import DeleteModal from '../../components/JobProfile/DeleteModal';
/*import { Alert } from 'react-bootstrap';*/
import Alert from 'react-bootstrap/Alert';
import Modal from 'react-bootstrap/Modal';
import '../AddLoads/DispatchModal.scss';
import { CustomButton } from '../_common';
import dispatchIcon from '../../assets/dispatchSuccess.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
interface DriverItemProps {
    driver: Driver;
    index: number;
    canEditDrivers: boolean;
    canEditSBXDrivers: boolean;
    onEditClick: (driver: Driver) => void;
    onDelete?: (record: any) => void;
}

const DriverItem = ({
    driver,
    index,
    canEditDrivers,
    canEditSBXDrivers,
    onEditClick,
    onDelete,
}: DriverItemProps): React.ReactElement => {
    const {
        driverType,
        name,
        regionName,
        districtName,
        cdlNumber,
        cdlExpiryDate,
        activeInactiveDate,
        activeInactiveUser,
        isActive,
        isShiftStarted,
        companyName,
        kronosId,
        cellPhone,
        driverPool,
        extSystemIdentifier3,
        trainingStatus,
        isAvailable,
        checkInWithBellyDump,
    } = driver;
    const isOdd = index % 2 == 1;
    const containerStyle = `DriversItem-Bottom-Container ${!isOdd && 'DriversItem-Bottom-Container-With-Background'}`;
    const UNAVAILABLE_DATE = '';
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [show, setShow] = useState(false);
    const endDriverShiftMessage = 'You need to end the driver "'
        .concat(driver.name)
        .concat('" shift to delete the driver');
    const handleDelete = () => {
        onDelete && onDelete(driver);
        setDeleteConfirm(false);
    };
    const handleDriverShift = () => {
        //this enables the enddrivershift modal box if dispatch tries to delete the driver while driver is on a shift
        if (isShiftStarted != true) {
            setDeleteConfirm(true);
        } else {
            setShow(true);
        }
    };
    return (
        <div className={containerStyle}>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header" style={{ display: 'flex' }}>
                    {/* {trainingStatus === 2 ? (
                        <div className="expired"></div>
                    ) : trainingStatus === 3 ? (
                        <div className="pass"></div>
                    ) : (
                        <div className="fail"></div>
                    )} */}
                    {name}
                    {isAvailable === false && (
                        <span className="conv-icon off-shift" title="Driver not available">
                            <FontAwesomeIcon icon={['fas', 'ban']} color="#FF0000" />
                        </span>
                    )}
                    <span
                            className="conv-icon on-shift"
                            title={
                                checkInWithBellyDump
                                    ? 'Checked in with belly dump (hopper)'
                                    : 'Checked in with box'
                            }
                        >
                            <FontAwesomeIcon
                                icon={['fas', checkInWithBellyDump ? 'dumpster' : 'cube']}
                                color="#b6bd00"
                            />
                    </span>
                </div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{regionName}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{districtName}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{extSystemIdentifier3}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">
                    {trainingStatus == 2 || trainingStatus == 3 ? 'Compliant' : 'Not Compliant'}
                </div>
            </div>
            {/* <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{cdlNumber}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{districtName}</div>
            </div> */}

            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">
                    {activeInactiveDate ? formatDateUtcToLocal(activeInactiveDate) : UNAVAILABLE_DATE}
                </div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{activeInactiveUser}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{companyName}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{driverType}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{cellPhone}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{driverPool}</div>
            </div>
            <div className="d-flex flex-column justify-content-between my-flex-container col-md-1">
                <div className="DriversItem-List-Header">{isActive ? 'Active' : 'Inactive'}</div>
            </div>
            {/* {!canEditDrivers && <div className="GridViewItem-List-Header"></div>} */}
            {/* {(canEditDrivers || canEditSBXDrivers) && ( */}
            <div className="GridViewItem-List-Header">
                {/* {canEditDrivers && driver.driverType != 'SBX' && (
                        <div
                            className={` ${
                                canEditDrivers ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                            }`}
                            onClick={() => onEditClick(driver)}
                        >
                            <i className="material-icons UsersItem-Icon">edit</i>
                            <span className="UsersItem-Link">Edit</span>
                        </div>
                    )} */}
                {/* {canEditSBXDrivers && driver.driverType == 'SBX' && (
                        <div
                            className={` ${
                                canEditDrivers ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                            }`}
                            onClick={() => onEditClick(driver)}
                        >
                            <i className="material-icons UsersItem-Icon">edit</i>
                            <span className="UsersItem-Link">Edit</span>
                        </div>
                    )} */}
                <div className={'GridViewItem-Edit-Container'} onClick={() => onEditClick(driver)}>
                    <i className="material-icons UsersItem-Icon">edit</i>
                    <span className="UsersItem-Link">Edit</span>
                </div>

                {/*  function handleDriverShift() verified if driver is on shift or not when dispatch clicks on Delete button  */}

                {canEditDrivers && onDelete && driver.loadId == null && driver.driverType === 'CP' && (
                    <div onClick={() => handleDriverShift()} className={` ${'GridViewItem-Edit-Container'}`}>
                        &nbsp;|&nbsp;
                        <i className="material-icons UsersItem-Icon">delete</i>
                        <span className="UsersItem-Link">Delete</span>
                    </div>
                )}
                {/*  Ends here JJ - 983 code */}
                {canEditSBXDrivers && onDelete && driver.loadId == null && driver.driverType === 'SBX' && (
                    <div onClick={() => handleDriverShift()} className={` ${'GridViewItem-Edit-Container'}`}>
                        &nbsp;|&nbsp;
                        <i className="material-icons UsersItem-Icon">delete</i>
                        <span className="UsersItem-Link">Delete</span>
                    </div>
                )}
            </div>
            {/* )} */}
            <DeleteModal
                show={deleteConfirm}
                name={'driver'}
                onConfirm={handleDelete}
                onCancel={() => setDeleteConfirm(false)}
            />
            {/* Belwo Modal appears when dispatch tries to delete the driver while driver's on a shift */}
            <Modal show={show} onHide={() => setShow(false)} backdrop="static">
                <Modal.Header className="ConfirmDispatchModal-Header">
                    <Modal.Title className="ConfirmDispatchModal-Header-Container">
                        <i className="material-icons ConfirmDispatchModal-X-Button" onClick={() => setShow(false)}>
                            close
                        </i>
                        <img className="ConfirmDispatchModal-Icon" src={dispatchIcon} alt="dispatch icon" />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="ConfirmDispatchModal-Body">
                    <div className="ConfirmDispatchModal-Body-Header">{endDriverShiftMessage}</div>
                </Modal.Body>
                <Modal.Footer className="ConfirmDispatchModal-Footer">
                    <CustomButton title="OK" isDisabled={false} onClick={() => setShow(false)}></CustomButton>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DriverItem;

